/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import React from 'react'
import Footer from '../Common/Footer'
import ResponsiveContainer from "../Common/ResponsiveContainer";
import {Grid, Header} from "semantic-ui-react";
import styles from '../../components/Components.module.css'
import 'semantic-ui-css/semantic.min.css';
import {Link} from "react-router-dom";
import Rij from "../Common/Rij";

const Stukken = () => (
    <ResponsiveContainer>
        <Grid container centered stackable>
            <Rij header={'Stukken'}>
                <Header as={'h1'} style={{fontSize: '3.6em'}}>Stukken</Header>
                <p className={styles.rijP} style={{fontStyle: 'inherit', marginTop: '4em'}}>
                    Ik schrijf graag over mensen en de manier waarop zij leven in de vorm van reportages, interviews, rubrieken en columns.
                    Iedereen heeft een verhaal. Iedereen is interessant.
                    Dat is mijn uitgangspunt wanneer ik met een kladblok in de hand op pad ga.
                    Thema's waar ik vaak over schrijf:
                </p>
            </Rij>
            <Rij header={''}>
                <Header as={'h3'} style={{fontSize: '1.2rem'}}>Levenslessen</Header>
                <p className={styles.rijP}>
                    Hoe we volgens Fresku
                    <Link
                        to={'https://www.nrc.nl/nieuws/2021/06/01/daar-was-iedereen-pas-echt-stijlvol-a4044627'}
                        className={styles.standardLink}
                    > ons leven kunnen verlengen</Link>.
                    Gijs raakte
                    <Link to={'https://www.nrc.nl/nieuws/2018/08/31/ik-probeerde-te-zwemmen-maar-er-gebeurde-gewoon-niks-a1614884'}
                          className={styles.standardLink}> verlamd </Link>tijdens zijn clubvakantie, en wordt nu per toerbeurt door zijn vrienden
                    verzorgd.
                    Welk effect had de
                    <Link to={'https://www.nrc.nl/nieuws/2020/05/15/het-is-stil-op-straat-maar-je-hoort-de-buren-meer-a3999861'}
                          className={styles.standardLink}> geluidsdaling</Link> tijdens corona?
                    Drie tieners runnen
                    <Link to={'https://www.parool.nl/nieuws/op-school-makandra-in-zuidoost-zijn-drie-tieners-de-baas~b1a147df/'}
                    className={styles.standardLink}> school Makandra</Link> in Amsterdam Zuidoost. Mohammed
                    <Link to={'https://www.nrc.nl/nieuws/2018/01/19/hij-bestal-vroeger-toeristen-nu-helpt-hij-daklozen-en-dealers-a1589042'}
                          className={styles.standardLink}> bestal vroeger toeristen</Link>, nu helpt hij
                    daklozen en dealers.
                    Waarom we
                    <Link to={'https://www.nrc.nl/nieuws/2023/10/10/dit-is-geen-keuze-en-al-helemaal-geen-gebrek-a4176654'}
                          className={styles.standardLink}> verlegenheid</Link> moeten omarmen in plaats van overwinnen.
                </p>
            </Rij>

            <Rij header={''}>
                <Header as={'h3'} style={{fontSize: '1.2rem'}}>(Psychische) gezondheid</Header>
                <p className={styles.rijP}>
                    Je kunt ook
                    <Link to={'https://www.nrc.nl/nieuws/2019/09/06/je-kunt-voor-verslavingshulp-ook-het-buitenland-is-die-zorg-beter-a3972484'}
                          className={styles.standardLink}> afkicken in het buitenland</Link>, is die zorg beter?
                    Ik vroeg een dieetpsycholoog hoe ik geestelijke gezond kan
                    <Link to={'https://www.vice.com/nl/article/afvallen-dieet-overgewicht-gezond-eten/'}
                          className={styles.standardLink}> afvallen</Link>.
                    Ex-kankerpatiënten kunnen verlamd worden door
                    <Link to={'https://www.nrc.nl/nieuws/2018/02/16/altijd-bang-dat-die-ziekte-terugkomt-a1592527'}
                          className={styles.standardLink}> de angst dat de ziekte terugkomt</Link>.
                    Waarom het gezond is om
                    <Link to={'https://www.nrc.nl/nieuws/2018/11/14/in-de-vrije-natuur-is-er-geen-beest-met-overgewicht-a2755207'}
                          className={styles.standardLink}> als een beest</Link> te leven.
                    ‘Ik neem wel een boterham’ – goed eten is niet vanzelfsprekend voor
                    <Link to={'https://www.nrc.nl/nieuws/2018/11/14/in-de-vrije-natuur-is-er-geen-beest-met-overgewicht-a2755207'}
                          className={styles.standardLink}> ouderen</Link>.
                    Hoe help je een
                    <Link to={'https://www.nrc.nl/nieuws/2018/01/14/vraag-liever-niet-elke-dag-hoe-het-gaat-a1588157'}
                          className={styles.standardLink}> depressieve naaste</Link>?
                    Met
                    <Link to={'https://www.standaard.be/cnt/dmf20190102_04074247'}
                          className={styles.standardLink}> droomtraining</Link> kan je grip krijgen op je nachtmerries.
                    Waarom had de
                    <Link to={'https://www.nrc.nl/nieuws/2020/05/15/het-is-stil-op-straat-maar-je-hoort-de-buren-meer-a3999861'}
                          className={styles.standardLink}> geluidsdaling</Link> tijdens corona een positief effect op onze gezondheid?

                </p>
            </Rij>

            <Rij header={''}>
                <Header as={'h3'} style={{fontSize: '1.2rem'}}>Cultuur</Header>
                <p className={styles.rijP}>
                    Is <Link to={'https://www.nrc.nl/nieuws/2017/05/02/kindermoord-is-niet-grappig-8503387-a1556750'}
                             className={styles.standardLink}> museumhumor</Link> een goed idee?
                    <Link to={'https://www.nrc.nl/nieuws/2018/03/29/de-band-die-ex-joegoslaven-samenbrengt-a1597641'}
                          className={styles.standardLink}> De Rolling Stones van de Balkan </Link>
                    brengen ex-Joegoslaven bij elkaar. Waarom we
                    <Link to={'https://www.nrc.nl/nieuws/2017/03/28/trippen-in-het-museum-7660273-a1552186'}
                          className={styles.standardLink}> misselijk worden van optische kunst</Link>.
                    <Link to={'https://www.nrc.nl/nieuws/2017/05/11/hits-ontdekken-geeft-me-een-geweldige-kick-8773990-a1558061'}
                          className={styles.standardLink}> Meester Jesper</Link> beheert de grootste particuliere afspeellijst
                    op Spotify Nederland.
                    <Link to={'https://www.nrc.nl/nieuws/2018/12/07/the-chippendales-ja-die-zijn-er-dus-nog-a3059898'}
                          className={styles.standardLink}> De Chippendales</Link>? Ja die zijn er dus nog. Drie
                    <Link to={'https://www.nrc.nl/nieuws/2017/05/31/poezie-van-de-straat-10812494-a1561124'}
                          className={styles.standardLink}> jonge vrouwelijke spokenwordartiesten </Link>
                    over waarom zij op het podium staan.
                </p>
            </Rij>

            <Rij header={''}>
                <Header as={'h3'} style={{fontSize: '1.2rem'}}>Het moderne leven</Header>
                <p className={styles.rijP}>
                    Waarom we steeds vaker onze
                    <Link to={'https://www.nrc.nl/nieuws/2019/01/28/ik-ben-helemaal-geen-tamaarah-a3652071'}
                          className={styles.standardLink}> voornaam veranderen</Link>. Gooi je als stel alles op één hoop, of houd je je
                    <Link to={'https://www.nrc.nl/nieuws/2019/08/01/gooi-je-als-stel-alles-op-een-hoop-of-houd-je-je-geld-gescheiden-a3968844'}
                          className={styles.standardLink}> geld</Link> gescheiden? Hoe het is om een
                    <Link to={'https://hardhoofd.com/tip-geen-kassameisje/'}
                          className={styles.standardLink}> kassameisje</Link> te zijn en meerderjarigen om hun ID te moeten vragen.
                    Als wij naar de zon vertrekken, gunnen we onze huisdieren ook
                    <Link to={'https://www.nrc.nl/nieuws/2018/08/17/een-bed-brokken-voor-tijdens-de-vakantie-a1613392'}
                          className={styles.standardLink}> een fijne vakantie</Link>. Hoe kun je
                    <Link to={'https://www.nrc.nl/nieuws/2017/08/06/meer-gedoe-minder-afval-12398820-a1569069'}
                          className={styles.standardLink}> duurzaam menstrueren</Link>?
                    Trouwen wordt minder populair, liever gaan we
                    <Link to={'https://www.nrc.nl/nieuws/2017/11/13/wil-je-met-me-registreren-13518035-a1580897'}
                          className={styles.standardLink}> registreren</Link>.
                </p>
            </Rij>

            <Rij header={''}>
                <Header as={'h3'} style={{fontSize: '1.2rem'}}>Vrije tijd</Header>
                <p className={styles.rijP}>

                    Nederland is een hobbyland.
                    Het aantal originele vrijetijdsbestedingen is eindeloos. Van
                    <Link to={'https://www.nrc.nl/nieuws/2022/06/17/vrij-a4133547'}
                          className={styles.standardLink}> stokpaardspringen</Link> tot
                    <Link to={'https://www.nrc.nl/nieuws/2022/04/08/vrij-70-a4108419'}
                          className={styles.standardLink}> gongen</Link>, van
                    <Link to={'https://www.nrc.nl/nieuws/2019/06/06/vrij-a3962752'}
                          className={styles.standardLink}> wedstrijdpijproken </Link>
                    tot
                    <Link to={'https://www.nrc.nl/nieuws/2020/03/12/vrij-a3993394'}
                          className={styles.standardLink}> een gigantisch poppenhuis bouwen </Link>
                    en van
                    <Link to={'https://www.nrc.nl/nieuws/2019/11/14/vrij-a3980238'}
                          className={styles.standardLink}> koivissen houden </Link>
                    tot
                    <Link to={'https://www.nrc.nl/nieuws/2021/05/06/vrij-a4042532'}
                          className={styles.standardLink}> jagen op kraaien</Link>.<br/><br/>
                    Ook betekenen we graag iets goeds voor andere mensen.
                    We zijn <Link to={'https://www.nrc.nl/nieuws/2023/01/19/samen-doen-we-het-lekker-rustig-aan-2-a4154572'}
                                  className={styles.standardLink}> oppasoma
                </Link> voor een gehandicapt dwergkeesje, worden vrijwilliger
                    bij een <Link to={'https://www.nrc.nl/nieuws/2024/01/17/ik-wilde-bij-het-cluppie-horen-a4187280'}
                                  className={styles.standardLink}> poppodium</Link>, zijn
                    <Link to={'https://www.nrc.nl/nieuws/2022/10/13/een-mascotte-is-belangrijk-voor-het-clubgevoel-a4144943'}
                          className={styles.standardLink}> mascotte</Link> bij een voetbalvereniging,
                    chauffeuren ouderen in een
                    <Link to={'https://www.nrc.nl/nieuws/2023/03/29/ik-rij-gewoon-mensen-heen-en-weer-a4160752'}
                          className={styles.standardLink}> mini-auto</Link> door een winkelcentrum,
                    worden lid van groepen die
                    <Link to={'https://www.nrc.nl/nieuws/2023/02/17/lekker-naar-buiten-om-te-knotten-a4157201'}
                          className={styles.standardLink}> wilgen knotten</Link>, en speuren verloren trouwringen
                    op met
                    <Link to={'https://www.nrc.nl/nieuws/2020/08/12/een-plons-en-daar-gaat-je-trouwring-a4008591'}
                          className={styles.standardLink}> metaaldetectors</Link>.
                </p>
            </Rij>

        </Grid>
        <Footer/>
    </ResponsiveContainer>
)

export default Stukken
